import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function EditingIcon({
  className,
  fill,
  height,
  stroke,
  width,
}: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      className={className}
      fill={fill ?? 'currentColor'}
      height={height ?? 24}
      stroke={stroke}
      viewBoxDimensions="0 0 24 24"
      width={width ?? 24}
    >
      <g fill={fill ?? 'none'} fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g stroke={stroke ?? IconColors.DarkGrey}>
          <path d="M18.869 6.131c.428.43.667 1.013.663 1.62-.004.607-.251 1.187-.685 1.61l-9.063 9.063-4.315 1.107 1.106-4.315 9.063-9.063c.424-.434 1.004-.68 1.61-.684.607-.005 1.19.234 1.62.662zM6.576 15.215l3.212 3.206-3.212-3.206z" />
        </g>
      </g>
    </SimpleIcon>
  );
}
